import Utils from "platform/util/Utils";

enum NotificationTab {

    All = "all",
    Unread = "unread",
    Trade = "trade",
    Academy = "academy"
}

namespace NotificationTab {

    export function deserialize(sNotificationTab: string): NotificationTab {
        if (Utils.isNotEmpty(sNotificationTab)) {
            switch (sNotificationTab) {
                case NotificationTab.Unread:
                    return NotificationTab.Unread;
                case NotificationTab.Trade:
                    return NotificationTab.Trade;
                case NotificationTab.Academy:
                    return NotificationTab.Academy;
            }
        }
        return NotificationTab.All;
    }
}

export {
    NotificationTab
};
